import { Dispatch, SetStateAction, useState } from 'react';

type UseResetStateReturnType<T> = [T, Dispatch<SetStateAction<T>>, () => void];

export const useResetState = <T>(initialState: T): UseResetStateReturnType<T> => {
  const [state, setState] = useState(initialState);
  const reset = () => setState(initialState);
  return [state, setState, reset];
};
